export const decodeDocument = (content) => {
  return atob(content);
};



// WEBPACK FOOTER //
// ./src/utils/documentsHelper.js